import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { t } from '../../../../locales';
import {
  resolveLocalizedText,
  resolvePublicAssets,
  isApp,
} from '../../../../utils';
import { OffersFormConfig } from '../../types';
import {
  getOffersFormConfig,
  getOffersFormData,
} from '../../selectors/offersSelector';
import { OffersFormInfoView } from '../../components/OffersFormInfoView';
import { OffersFormDependentView } from '../../components/OffersFormDependentView';
import {
  updateOffersForm,
  updateOffersIsReview,
  updatePromotionChecked,
  updatePromotionCode,
} from '../../actions/offersFormAction';
import { goto, hideBackButton } from '../../../../actions/historyActions';
import { getCustomer } from '../../../../selectors/userSelectors';
import { validateDateOfBirth } from '../../../../utils';
import './styles.scss';
import imgPlus from '../../../../assets/images/plus@3x.png';
import { CUSTOMER_GENDER } from '../../../../constants/constants';

export interface OffersFormContainerProps {
  offersFormConfig: OffersFormConfig;
  offersInfoConfig: any;
  formDependentConfig: any;
  offersData: {
    infoObj: any;
    dependentArr: Array<any>;
  };
  prefillData: any;
  updateOffersFormData: (offersData: any) => void;
  onHideBackButton: () => void;
  isReview: boolean;
  updateOffersIsReviewData: () => void;
  updatePromotionChecked: (checked: boolean) => void;
  promotionErrorCode: string;
  updatePromotionCode: (promotionErrorCode: string) => void;
}

interface OffersFormContainerState {
  infoObjState: any;
  dependentArrState: Array<any>;
  infoErrors: boolean;
  dependentErrors: boolean;
  prefillDataState: any;
  // Policy modal
  isShowModal: boolean;
  setShowModalFlag: boolean;

  agreeCollectionStatement: boolean;
  agreePromotion: boolean;
}

export class OffersFormContainer extends Component<
  OffersFormContainerProps,
  OffersFormContainerState
> {
  constructor(props: any = {}) {
    super(props);

    const initInfoObj = {
      name: '',
      gender: '',
      birthday: '',
      email: '',
      mobileCountryCode: '852',
      mobile: '',
      consultantMobileCountryCode: '852',
      consultantMobile: '',
      product: '',
      promotionCode: '',
      agentCode: '',
    };
    const offersDataRedux = props.offersData;
    const infoRedex =
      offersDataRedux && offersDataRedux.infoObj
        ? offersDataRedux.infoObj
        : initInfoObj;
    const dependentArrRedux =
      offersDataRedux &&
      offersDataRedux.dependentArr &&
      offersDataRedux.dependentArr.length > 0
        ? offersDataRedux.dependentArr
        : [];
    this.state = {
      infoObjState: infoRedex,
      dependentArrState: dependentArrRedux,
      infoErrors: true,
      dependentErrors: false,
      prefillDataState: props.prefillData
        ? props.prefillData
        : {
            isPOAccount: false,
            name: '',
            gender: '',
            date: '',
            month: '',
            year: '',
            email: '',
            mobileNo: '',
            product: '',
            promotionCode: '',
            agentCode: '',
          },
      // Policy modal
      isShowModal: false,
      setShowModalFlag: false,

      agreeCollectionStatement: false,
      agreePromotion: false,
    };

    this.updateInfoObjState = this.updateInfoObjState.bind(this);
    this.addDependentForm = this.addDependentForm.bind(this);
    this.reduceDependentForm = this.reduceDependentForm.bind(this);
    this.changeDependentState = this.changeDependentState.bind(this);
    this.onShowModal = this.onShowModal.bind(this);
    this.onHideModal = this.onHideModal.bind(this);
    this.back = this.back.bind(this);
    this.nextButtonHandler = this.nextButtonHandler.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);

    const initOffersData = {
      infoObj: infoRedex,
      dependentArr: dependentArrRedux,
    };
    this.props.updateOffersFormData(initOffersData);
  }

  componentWillReceiveProps(nextProps: OffersFormContainerProps) {
    if (
      nextProps.prefillData.isPOAccount &&
      nextProps.prefillData.isPOAccount != this.props.prefillData.isPOAccount
    ) {
      const nextPrefillData = nextProps.prefillData;
      const { name, gender, date, month, year, email, mobileNo } =
        nextPrefillData;
      const {
        mobileCountryCode,
        consultantMobileCountryCode,
        consultantMobile,
      } = this.state.infoObjState;
      this.setState(
        {
          prefillDataState: nextPrefillData,
          infoObjState: {
            name: name ? name : '',
            gender: gender ? gender : '',
            birthday:
              date && month && year
                ? validateDateOfBirth(year, month, date)
                  ? ``
                  : `${year}${month}${date}`
                : '',
            email: email ? email : '',
            mobileCountryCode: mobileCountryCode ? mobileCountryCode : '852',
            mobile: mobileNo ? mobileNo : '',
            consultantMobileCountryCode: consultantMobileCountryCode
              ? consultantMobileCountryCode
              : '852',
            consultantMobile: consultantMobile ? consultantMobile : '',
          },
        },
        () => {
          this.updateInfoErrors(this.state.infoObjState);
        },
      );
    }
  }

  componentDidMount() {
    // this.props.onHideBackButton();
    this.bindOnClickFunc();
  }

  bindOnClickFunc() {
    const ele = document.getElementById('vaccination-tnc-link'); // this id is from the profile api content.
    if (ele) {
      ele.addEventListener('click', () => {
        this.onShowModal();
      });
    }
  }

  isValidMobileNumber(countryCode: string, mobileNo: string) {
    const mobileLen = mobileNo.length;
    if (RegExp(/[^0-9]/).test(mobileNo)) return false;
    if (countryCode === '86') {
      return mobileLen === 11;
    } else if (countryCode === '852' || countryCode === '853') {
      return mobileLen === 8;
    } else if (countryCode === '886') {
      if (mobileNo.substr(0, 1) === '9') {
        return mobileLen === 9;
      }
      if (mobileNo.substr(0, 2) === '09') {
        return mobileLen === 10;
      }
    }
    return false;
  }

  updateInfoObjState(label: any, value: any) {
    const { infoObjState } = this.state;
    infoObjState[label] = value;
    this.setState({
      infoObjState: infoObjState,
    });
    this.updateInfoErrors(infoObjState);
  }

  updateInfoErrors(infoObjState: any) {
    const { offersInfoConfig } = this.props;
    const { isSportsPaOfferPromo } =
      offersInfoConfig && offersInfoConfig.promotionCode;
    const isHasPromoCodeCorrect =
      isSportsPaOfferPromo &&
      infoObjState.promotionCode &&
      infoObjState.promotionCode.length === 6;
    const isNonePromoCodeCorrect =
      !isSportsPaOfferPromo &&
      ((infoObjState.promotionCode &&
        infoObjState.promotionCode.length === 6) ||
        infoObjState.promotionCode === '');
    const isPromoCodeCorrect = isHasPromoCodeCorrect || isNonePromoCodeCorrect;
    const isAgentCodeCorrect =
      infoObjState.agentCode === '' ||
      (infoObjState.agentCode && infoObjState.agentCode.length === 6);
    if (
      infoObjState.name &&
      infoObjState.gender &&
      infoObjState.birthday &&
      infoObjState.email &&
      infoObjState.mobileCountryCode &&
      infoObjState.mobile &&
      (!infoObjState.consultantMobile ||
        this.isValidMobileNumber(
          infoObjState.consultantMobileCountryCode,
          infoObjState.consultantMobile,
        )) &&
      infoObjState.product &&
      isPromoCodeCorrect &&
      isAgentCodeCorrect
    ) {
      this.setState({
        infoErrors: false,
      });
    } else {
      this.setState({
        infoErrors: true,
      });
    }
  }

  addDependentForm() {
    const { dependentArrState } = this.state;
    if (dependentArrState && dependentArrState.length < 4) {
      dependentArrState.push({
        relationship: '',
        fullName: '',
        gender: '',
        birthday: null,
      });
      this.updateDependentErrorsState(dependentArrState);
      this.setState({
        dependentArrState: dependentArrState,
      });
    }
  }

  reduceDependentForm(reduceIndex: number) {
    const { dependentArrState } = this.state;
    dependentArrState.splice(reduceIndex, 1);
    this.updateDependentErrorsState(dependentArrState);
    this.setState({
      dependentArrState: dependentArrState,
    });
  }

  changeDependentState(dependentArr: Array<any>) {
    this.updateDependentErrorsState(dependentArr);
    this.setState({
      dependentArrState: dependentArr,
    });
  }

  updateDependentErrorsState(dependentArr: any) {
    if (dependentArr && dependentArr.length > 0) {
      dependentArr.forEach((ele: any) => {
        if (ele.birthday && ele.fullName && ele.gender && ele.relationship) {
          this.setState({
            dependentErrors: false,
          });
        } else {
          this.setState({
            dependentErrors: true,
          });
        }
      });
    } else {
      this.setState({
        dependentErrors: false,
      });
    }
  }

  // policy modal
  onShowModal() {
    this.setState({
      isShowModal: true,
    });
  }
  onHideModal() {
    this.setState({
      isShowModal: false,
    });
  }

  back() {
    goto('emma-myprivileges-sportspaoffers');
  }

  nextButtonHandler(event: any) {
    event.preventDefault();
    const { infoObjState, dependentArrState } = this.state;
    const url = new URL(window.location.href);
    const gaClientId = url.searchParams.get(`clientId`) || '';
    const gaTrackId = url.searchParams.get(`axaId`) || '';
    const offersData = {
      infoObj: infoObjState,
      dependentArr: dependentArrState,
      gaClientId: gaClientId,
      gaTrackId: gaTrackId,
    };
    this.props.updateOffersFormData(offersData);
    this.props.updateOffersIsReviewData();
    goto('emma-free-offers-review');
  }

  onChangeCheckbox(event: any) {
    this.setState({
      [event.target.name]: event.target.checked,
    } as any);
    if (event.target.name === 'agreePromotion') {
      this.props.updatePromotionChecked(event.target.checked);
    }
  }

  render() {
    const {
      offersFormConfig,
      offersInfoConfig,
      formDependentConfig,
      offersData,
      isReview,
      promotionErrorCode,
      updatePromotionCode,
    } = this.props;
    const {
      dependentArrState,
      infoErrors,
      dependentErrors,
      isShowModal,
      prefillDataState,
      agreeCollectionStatement,
      agreePromotion,
    } = this.state;
    const dependentArray =
      offersData &&
      offersData.dependentArr &&
      offersData.dependentArr.length > 0
        ? offersData.dependentArr
        : dependentArrState;
    const offersFormInfoViewProps = {
      offersInfoConfig: offersInfoConfig,
      updateInfoObjState: this.updateInfoObjState,
      updatePromotionCode,
      offersData: offersData,
      prefillData: prefillDataState,
      isReview: isReview,
      promotionErrorCode,
    };
    const offersFormDependentViewProps = {
      formDependentConfig: formDependentConfig,
      dependentArr: dependentArray,
      reduceDependent: this.reduceDependentForm,
      changeDependent: this.changeDependentState,
      offersData: offersData,
    };

    const canButtonProceed =
      !(infoErrors || dependentErrors) && agreeCollectionStatement;

    const checkIsApp = isApp();
    // {!checkIsApp && <BackNavButton backPath="emma-myprivileges-vaccination" />}
    return (
      <div className="emma-stylesheet-grid-system offers-form-container">
        <div className="offers-form__title">{offersFormConfig.title}</div>
        <form className="offers-form-content" onSubmit={this.nextButtonHandler}>
          <div className="offers-form__tips">{offersFormConfig.tips}</div>
          <div className="offers-form__remarks">
            <span className="offers-form-information__red-star">*</span>
            {offersFormConfig.remarks}
          </div>
          <div className="offers-form__information-title">
            {offersFormConfig.informationTitle}
          </div>
          <OffersFormInfoView {...offersFormInfoViewProps} />
          {dependentArray.map((ele: any, index: any) => {
            return (
              <OffersFormDependentView
                key={index}
                dependentIndex={index}
                {...offersFormDependentViewProps}
              />
            );
          })}
          {dependentArrState.length < 4 && (
            <div
              className="offers-form-dependent__button"
              onClick={this.addDependentForm}
              data-enable-ga
              data-ga-type="button"
            >
              <button
                type="button"
                className="emma-stylesheet-primary-mobile-ghost-button"
              >
                <img src={imgPlus} width="24" height="24" />{' '}
                {formDependentConfig.button}
              </button>
            </div>
          )}
          <div className="offers-form-dependent__remarks">
            {formDependentConfig.remarks}
          </div>
          <div className="offers-form__details">
            <div className="emma-stylesheet-checkbox-big">
              <input
                id="agreeCollectionStatement"
                name="agreeCollectionStatement"
                type="checkbox"
                value="Y"
                onChange={this.onChangeCheckbox}
                checked={agreeCollectionStatement}
              />
              <label htmlFor="agreeCollectionStatement"></label>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: memoSanitize(offersFormConfig.sportsPAdetails1),
              }}
            ></div>
          </div>

          <div className="offers-form__details">
            <div className="emma-stylesheet-checkbox-big">
              <input
                id="agreePromotion"
                name="agreePromotion"
                type="checkbox"
                value="Y"
                onChange={this.onChangeCheckbox}
                checked={agreePromotion}
              />
              <label htmlFor="agreePromotion"></label>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: memoSanitize(offersFormConfig.sportsPAdetails2),
              }}
            ></div>
          </div>

          <div className="offers-form__button">
            <button
              className={`emma-stylesheet-input  offers-form__button-submit ${
                !canButtonProceed
                  ? 'emma-stylesheet-primary-secondary-default-disabled-button'
                  : 'emma-stylesheet-primary-default-button'
              }`}
              disabled={!canButtonProceed}
              type="submit"
              data-enable-ga={canButtonProceed}
              data-ga-type="button"
            >
              {t('OK_I_UNDERSTAND_AND_LETS_PROCEED')}
            </button>
            <button
              className="emma-stylesheet-input emma-stylesheet-primary-ghost-button offers-form__button-cancle"
              onClick={this.back}
              data-enable-ga
              data-ga-type="button"
            >
              {t('NO_THANKS_BRING_ME_BACK')}
            </button>
          </div>
        </form>

        <Modal show={isShowModal} onHide={this.onHideModal}>
          <ModalHeader>
            <span>{t('OFFERS_FORM_POLICY_MODAL_HEADER')}</span>
          </ModalHeader>
          <ModalBody>
            <span
              dangerouslySetInnerHTML={{
                __html: memoSanitize(t('OFFERS_FORM_POLICY_MODAL_DETAILS')),
              }}
            ></span>
          </ModalBody>
          <ModalFooter>
            <div className="modal-footer-btn-align__right">
              <button
                className="emma-stylesheet-primary-default-button"
                onClick={this.onHideModal}
                data-enable-ga
                data-ga-type="button"
              >
                {t('CLOSE')}
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const offersFormConfig = getOffersFormConfig(state);
    const offersInfoConfig =
      offersFormConfig &&
      offersFormConfig.information &&
      offersFormConfig.information.form
        ? offersFormConfig.information.form
        : {};
    const formDependent =
      offersFormConfig && offersFormConfig.dependent
        ? offersFormConfig.dependent
        : {};
    const formDependentConfig =
      offersFormConfig &&
      offersFormConfig.dependent &&
      offersFormConfig.dependent.form
        ? offersFormConfig.dependent.form
        : {};

    const { isReview, offersData, promotionErrorCode } =
      getOffersFormData(state);

    const pOAccountData = getCustomer(state);

    const changeOptionList = (optionList: any = []) => {
      return optionList.map((item: any) => ({
        optionVal: item.optionVal ? resolveLocalizedText(item.optionVal) : '',
        optionTitle: item.optionTitle
          ? resolveLocalizedText(item.optionTitle)
          : '',
      }));
    };

    return {
      offersFormConfig: {
        title:
          offersFormConfig && offersFormConfig.title
            ? resolveLocalizedText(offersFormConfig.title)
            : '',
        tips:
          offersFormConfig && offersFormConfig.tips
            ? resolveLocalizedText(offersFormConfig.tips)
            : '',
        remarks:
          offersFormConfig && offersFormConfig.remarks
            ? resolveLocalizedText(offersFormConfig.remarks)
            : '',
        informationTitle:
          offersFormConfig &&
          offersFormConfig.information &&
          offersFormConfig.information.title
            ? resolveLocalizedText(offersFormConfig.information.title)
            : '',
        details:
          offersFormConfig && offersFormConfig.details
            ? resolveLocalizedText(offersFormConfig.details)
            : '',
        sportsPAdetails1:
          offersFormConfig && offersFormConfig.sportsPAdetails1
            ? resolveLocalizedText(offersFormConfig.sportsPAdetails1)
            : '',
        sportsPAdetails2:
          offersFormConfig && offersFormConfig.sportsPAdetails2
            ? resolveLocalizedText(offersFormConfig.sportsPAdetails2)
            : '',
      },
      offersInfoConfig: {
        name: {
          label:
            offersInfoConfig &&
            offersInfoConfig.name &&
            offersInfoConfig.name.label
              ? resolveLocalizedText(offersInfoConfig.name.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.name &&
            offersInfoConfig.name.errorMessage
              ? resolveLocalizedText(offersInfoConfig.name.errorMessage)
              : '',
        },
        gender: {
          label:
            offersInfoConfig &&
            offersInfoConfig.gender &&
            offersInfoConfig.gender.label
              ? resolveLocalizedText(offersInfoConfig.gender.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.gender &&
            offersInfoConfig.gender.errorMessage
              ? resolveLocalizedText(offersInfoConfig.gender.errorMessage)
              : '',
        },
        birthday: {
          label:
            offersInfoConfig &&
            offersInfoConfig.birthday &&
            offersInfoConfig.birthday.label
              ? resolveLocalizedText(offersInfoConfig.birthday.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.birthday &&
            offersInfoConfig.birthday.errorMessage
              ? resolveLocalizedText(offersInfoConfig.birthday.errorMessage)
              : '',
        },
        email: {
          label:
            offersInfoConfig &&
            offersInfoConfig.email &&
            offersInfoConfig.email.label
              ? resolveLocalizedText(offersInfoConfig.email.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.email &&
            offersInfoConfig.email.errorMessage
              ? resolveLocalizedText(offersInfoConfig.email.errorMessage)
              : '',
        },
        mobile: {
          label:
            offersInfoConfig &&
            offersInfoConfig.mobile &&
            offersInfoConfig.mobile.label
              ? resolveLocalizedText(offersInfoConfig.mobile.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.mobile &&
            offersInfoConfig.mobile.errorMessage
              ? resolveLocalizedText(offersInfoConfig.mobile.errorMessage)
              : '',
        },
        consultantMobile: {
          label:
            offersInfoConfig &&
            offersInfoConfig.consultantMobile &&
            offersInfoConfig.consultantMobile.label
              ? resolveLocalizedText(offersInfoConfig.consultantMobile.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.consultantMobile &&
            offersInfoConfig.consultantMobile.errorMessage
              ? resolveLocalizedText(
                  offersInfoConfig.consultantMobile.errorMessage,
                )
              : '',
        },
        product: {
          label:
            offersInfoConfig &&
            offersInfoConfig.product &&
            offersInfoConfig.product.label
              ? resolveLocalizedText(offersInfoConfig.product.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.product &&
            offersInfoConfig.product.errorMessage
              ? resolveLocalizedText(offersInfoConfig.product.errorMessage)
              : '',
          placeholder:
            offersInfoConfig &&
            offersInfoConfig.product &&
            offersInfoConfig.product.placeholder
              ? resolveLocalizedText(offersInfoConfig.product.placeholder)
              : '',
          options:
            offersInfoConfig &&
            offersInfoConfig.product &&
            offersInfoConfig.product.options
              ? changeOptionList(offersInfoConfig.product.options)
              : [],
        },
        promotionCode: {
          label:
            offersInfoConfig &&
            offersInfoConfig.promotionCode &&
            offersInfoConfig.promotionCode.label
              ? resolveLocalizedText(offersInfoConfig.promotionCode.label)
              : '',
          mandatoryLabel:
            offersInfoConfig &&
            offersInfoConfig.promotionCode &&
            offersInfoConfig.promotionCode.mandatoryLabel
              ? resolveLocalizedText(
                  offersInfoConfig.promotionCode.mandatoryLabel,
                )
              : '',
          isSportsPaOfferPromo:
            (offersFormConfig && offersFormConfig.isSportsPaOfferPromo) ||
            false,
        },
        agentCode: {
          label:
            offersInfoConfig &&
            offersInfoConfig.agentCode &&
            offersInfoConfig.agentCode.label
              ? resolveLocalizedText(offersInfoConfig.agentCode.label)
              : '',
          errorMessage:
            offersInfoConfig &&
            offersInfoConfig.agentCode &&
            offersInfoConfig.agentCode.errorMessage
              ? resolveLocalizedText(offersInfoConfig.agentCode.errorMessage)
              : '',
        },
      },
      formDependentConfig: {
        formTitle:
          formDependent && formDependent.formTitle
            ? resolveLocalizedText(formDependent.formTitle)
            : '',
        deleteIcon:
          formDependent && formDependent.deleteIcon
            ? resolvePublicAssets(formDependent.deleteIcon).replace(
                '.png',
                '@3x.png',
              )
            : '',
        relationship: {
          label:
            formDependentConfig.relationship &&
            formDependentConfig.relationship.label
              ? resolveLocalizedText(formDependentConfig.relationship.label)
              : '',
          errorMessage:
            formDependentConfig.relationship &&
            formDependentConfig.relationship.errorMessage
              ? resolveLocalizedText(
                  formDependentConfig.relationship.errorMessage,
                )
              : '',
        },
        name: {
          label:
            formDependentConfig.name && formDependentConfig.name.label
              ? resolveLocalizedText(formDependentConfig.name.label)
              : '',
          errorMessage:
            formDependentConfig.name && formDependentConfig.name.errorMessage
              ? resolveLocalizedText(formDependentConfig.name.errorMessage)
              : '',
        },
        gender: {
          label:
            formDependentConfig.gender && formDependentConfig.gender.label
              ? resolveLocalizedText(formDependentConfig.gender.label)
              : '',
          errorMessage:
            formDependentConfig.gender &&
            formDependentConfig.gender.errorMessage
              ? resolveLocalizedText(formDependentConfig.gender.errorMessage)
              : '',
        },
        birthday: {
          label:
            formDependentConfig.birthday && formDependentConfig.birthday.label
              ? resolveLocalizedText(formDependentConfig.birthday.label)
              : '',
          errorMessage:
            formDependentConfig.birthday &&
            formDependentConfig.birthday.errorMessage
              ? resolveLocalizedText(formDependentConfig.birthday.errorMessage)
              : '',
        },
        button:
          formDependent && formDependent.button
            ? resolveLocalizedText(formDependent.button).toUpperCase()
            : '',
        remarks:
          formDependent && formDependent.remarks
            ? resolveLocalizedText(formDependent.remarks)
            : '',
        ageMonth:
          formDependent && formDependent.ageMonth
            ? resolveLocalizedText(formDependent.ageMonth)
            : '',
      },
      offersData: offersData,
      prefillData: {
        isPOAccount: pOAccountData,
        name:
          pOAccountData && pOAccountData.englishName
            ? pOAccountData.englishName
            : '',
        gender:
          pOAccountData && pOAccountData.gender
            ? pOAccountData.gender.toUpperCase() === CUSTOMER_GENDER.MALE
              ? `${t('GENDER_MALE_OPTION')}`
              : `${t('GENDER_FEMALE_OPTION')}`
            : '',
        date:
          pOAccountData && pOAccountData.dateOfBirth
            ? moment(pOAccountData.dateOfBirth).format('DD')
            : '',
        month:
          pOAccountData && pOAccountData.dateOfBirth
            ? moment(pOAccountData.dateOfBirth).format('MM')
            : '',
        year:
          pOAccountData && pOAccountData.dateOfBirth
            ? moment(pOAccountData.dateOfBirth).format('YYYY')
            : '',
        email:
          pOAccountData && pOAccountData.email && pOAccountData.email.length > 0
            ? pOAccountData.email[0]
            : '',
        mobileNo: '',
      },
      isReview: isReview,
      promotionErrorCode,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      updateOffersFormData: (offersData: any) =>
        dispatch(updateOffersForm(offersData)),
      onHideBackButton: () => dispatch(hideBackButton()),
      updateOffersIsReviewData: () => dispatch(updateOffersIsReview()),
      updatePromotionChecked: (checked: boolean) =>
        dispatch(updatePromotionChecked(checked)),
      updatePromotionCode: (promotionErrorCode: string) =>
        dispatch(updatePromotionCode(promotionErrorCode)),
    };
  }
}

export default connect(
  OffersFormContainer.mapStateToProps,
  OffersFormContainer.mapDispatchToProps,
)(OffersFormContainer);
